<ng-container *ngIf="league; else noTableAvailable">
  <div class="container nested">
    <div class="row">
      <div class="col-md-8">
        <app-promo-banner style="margin-bottom: 16px"></app-promo-banner>
        <lib-ad-sponsor-banner
          *ngIf="league"
          [entityId]="isLeaguePage ? league.id : teamService.getCurrentTeamId()"
          [entityType]="isLeaguePage ? EntityType.League : EntityType.Team"
          [hideHeader]="true">
        </lib-ad-sponsor-banner>
        <lib-league-table
          [canExpand]="true"
          (emptyTable)="onEmptyTable()"
          [league]="league"
          [highlightTeamId]="teamService.getCurrentTeamId()"
          [showHeader]="showLeagueLinkInTable"></lib-league-table>
        <lib-betting-game-teaser *ngIf="league" [leagueId]="league.id"></lib-betting-game-teaser>
      </div>
      <div class="col-md-4 team-sidebar">
        <div class="row">
          <lib-ad class="mb-2 mx-auto"></lib-ad>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #noTableAvailable>
  <div class="container px-md-0">
    <div class="row">
      <div class="col-12">
        <p class="no-infos-available">Keine Tabelle verfügbar</p>
      </div>
    </div>
  </div>
</ng-template>
